$(document).ready(function() {
    const isMobile = window.matchMedia('(max-width: 700px)').matches;
    var currentQuestion = null;

    // dynamically append a start ovr button, add a class to the parent container for css targeting
     if ($('.btn-questions').length) {
        $('.btn-questions').before('<a href="#" class="btn-prev reload-link">Back</a>');
        $('.btn-questions').each(function() {
            var parent = $(this).parent();
            if (!parent.hasClass('btn-container-questions')) {
                parent.addClass('btn-container-questions');
            }
        });
     }
     
      $('.reload-link').click(function(event) {
          event.preventDefault();
          location.reload(); // Reload the page
      });
  
    if ($(".grand-fathers-component").length) {
        $(".btn-first").on('click', function() {
            var imgCount = $(".paragraph_image_bottle_container img").length;
            var notSelectedCount = $(".not-selected").length;
            
            if (notSelectedCount < imgCount) {
                secondStep();
            }
           
           return false;
        });
        
        $(".paragraph_image_bottle_container").on('click', function() {
            $(".paragraph_image_bottle_container img").addClass('not-selected');
            $(this).find('img').removeClass('not-selected');
        });
        
        $(".grandfathers_day_question_items--content").on('click', function() {
            $(".grandfathers_day_question_items--content.selected").removeClass('selected');
            
           $(this).addClass('selected'); 
        });
        
        $(".btn-next").on('click', function() {
            if (!$(this).hasClass('btn-first') && !$(this).hasClass('btn-last') && !$(this).hasClass('btn-start')) {
                var parentsContainer = $(this).parents(".paragraph--type--grandfathers-day-question");
                if (parentsContainer.find('.selected').length <= 0) {
                    return false;
                }
                
                var targetId = parentsContainer.find(".selected").data('target');
                
                if ($("#" + targetId).length <= 0) {
                    alert("No more target found");
                    return false;
                }
                parentsContainer.addClass('hidden');
                $("#" + targetId).removeClass('hidden');
            }
            return false;
        });
        
        $(".btn-start").on('click', function() {
            $(".grandfathers--intro").addClass('hidden');
            $(".grand-fathers-component").removeClass('hidden');
            return false;
        });
        
        $(".btn-last").on('click', function() {
            var parentsContainer = $(this).parents(".paragraph--type--grandfathers-day-question");
            
            var targetId = parentsContainer.find(".selected").data('target');
            // if ($("#" + targetId).length <= 0) {
                window.location.href = targetId;    
            // } else {
            //     parentsContainer.addClass('hidden');
            //     $("#" + targetId).removeClass('hidden');
            // }
            
            return false;
        });
    }
    
    if ($(".fathers-day-final").length) {
        $(".paragraph--type--hero-centralized-content .control--play").on('click', function() {
            
            playPauseVideo();
            
        });
        
        $(".desktop-video").on('click', function() {
            playPauseVideo();
        })
    }
    
    function playPauseVideo()
    {
        var video = $('.desktop-video').first()[0]; // Get the video element
        if (video.paused) {
            video.play();
            video.muted = false;
            $(this).css('opacity', 0);
        } else {
            video.pause();
            video.muted = true;
            $(this).css('opacity', 1);
        }
    }
    
    function secondStep()
    {
        $(".not-selected").parents(".paragraph--type--grandfathers-day-item").addClass('hidden');
        var source = $('.paragraph_image_bottle_container img:not(.not-selected)').parents(".paragraph--type--grandfathers-day-item");
        source.addClass('fullwidth');
        currentQuestion = source.find(".paragraph--type--grandfathers-day-question").first();
        var pictureContainer =  $('.paragraph_image_bottle_container img:not(.not-selected)').parents(".paragraph_image_bottle_container");
        $(".btn-first").addClass('hidden');
        $(".btn-first").parent().addClass('hidden');
        $(".grandfathers_day-title").addClass('hidden');
        source.find('.grandfathers_day_items-title').addClass('hidden');
        pictureContainer.addClass('hidden');
        currentQuestion.removeClass('hidden');
    }
});
